export default __webpack_public_path__ + "static/media/icon-hamburger.7764b7eb.svg";